import { render, staticRenderFns } from "./actorInfo.vue?vue&type=template&id=7bdccc8e&scoped=true&"
import script from "./actorInfo.vue?vue&type=script&lang=js&"
export * from "./actorInfo.vue?vue&type=script&lang=js&"
import style0 from "./actorInfo.vue?vue&type=style&index=0&id=7bdccc8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdccc8e",
  null
  
)

export default component.exports